import React from 'react';
import { Navigate, Route, useLocation } from 'react-router';

// Old addresses Google still crawls (Search Console, 2026-09-25). With no route
// of their own they fell through to the catch-all, which served crawlers a login
// form (securspace-ui#3057). The query string rides along: HubSpot tracking
// parameters are on some of these links.
const LEGACY_REDIRECTS: Readonly<Record<string, string>> = {
  '/customer-signup': '/buyer-signup',
  '/partner-signup': '/supplier-signup',
  '/how-it-works': '/#how-it-works',
};

const LegacyRedirect = ({ to }: { to: string }) => {
  const { search, hash } = useLocation();
  const [pathname, targetHash] = to.split('#');
  // A target section (e.g. "How it works") wins; otherwise keep the incoming one.
  return <Navigate replace to={{ pathname, search, hash: targetHash ? `#${targetHash}` : hash }} />;
};

export const legacyRedirectRoutes = () => Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
  <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
));
